import styled from 'styled-components';
import { PlusIcon } from '@rsos/assets/icons';

export const StyledTag = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 7px 4px 10px;
  font-size: 12px;
  position: relative;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.tabHighlight};
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const StyledHarmonyWrapper = styled.div`
  cursor: pointer;
  display: inline-block;
  padding: 1.5px;
  margin-right: 8px;
  margin-top: 8px;
  border-radius: 7px;
  color: ${({ theme }) => theme.colors.primaryText};
  background: linear-gradient(
    214deg,
    #ed25c1 20.41%,
    #a74fff 32.75%,
    #f096ff 40.15%,
    #ebcbe4 51.57%,
    #dec2d8 53.73%,
    #ef40be 66.37%,
    #874fff 72.85%,
    #4d25ed 79.64%
  );
`;

export const StyledPlusIcon = styled(PlusIcon)`
  margin-left: 4px;
  cursor: pointer;
`;
